import React from "react"

import { Link, useLocation } from "react-router-dom"

import { KEYLESS_DASHBOARD, useHasFeatureAccess } from "@/hooks/useFeatureFlags"

import UserDropdown from "./UserDropdown"
import RoleTeamGuard from "./guards/RoleTeamGuard"

const TopNavigation: React.FC = () => {
  const location = useLocation()
  const showVehicles = useHasFeatureAccess(KEYLESS_DASHBOARD)

  return (
    <nav className="bg-secondary shadow-md sticky top-0 z-50 border-b border-primary/20">
      <div className="max-w-[1600px] mx-auto flex justify-between items-center py-3 px-6">
        <div className="flex items-center space-x-6">
          <Link to="/applications" className="text-white font-bold text-xl">
            <img
              src="/images/96144df6-f8d3-4e53-89cd-54753f2ffd0f.png"
              alt="DriverHive"
              className="h-5 md:h-6 brightness-0 invert"
              title="DriverHive"
            />
          </Link>
          <div className="flex items-center space-x-1 md:space-x-4">
            <RoleTeamGuard roles={["Admin", "Manager", "DSP"]} fallback={null}>
              <Link
                to="/applications"
                className={`text-sm md:text-base px-3 py-1.5 rounded-md transition-colors ${
                  location.pathname.startsWith("/applications")
                    ? "text-white hover:bg-white/10"
                    : "text-white/60 hover:text-white/80"
                }`}
              >
                Applications
              </Link>
            </RoleTeamGuard>
            <RoleTeamGuard roles={["Manager", "DSP", "Admin"]} fallback={null}>
              <Link
                to="/people"
                className={`text-sm md:text-base px-3 py-1.5 rounded-md transition-colors ${
                  location.pathname === "/people"
                    ? "text-white hover:bg-white/10"
                    : "text-white/60 hover:text-white/80"
                }`}
              >
                People
              </Link>
            </RoleTeamGuard>
            <RoleTeamGuard roles={["Admin", "Manager", "DSP"]} fallback={null}>
              <Link
                to="/sheriff"
                className={`text-sm md:text-base px-3 py-1.5 rounded-md transition-colors ${
                  location.pathname === "/sheriff"
                    ? "text-white hover:bg-white/10"
                    : "text-white/60 hover:text-white/80"
                }`}
              >
                Sheriff
              </Link>
            </RoleTeamGuard>
            <RoleTeamGuard
              roles={["Admin", "Manager"]}
              fallback={null}
              teams={["Central Operations"]}
            >
              <Link
                to="/collections"
                className={`text-sm md:text-base px-3 py-1.5 rounded-md transition-colors ${
                  location.pathname.startsWith("/collections")
                    ? "text-white hover:bg-white/10"
                    : "text-white/60 hover:text-white/80"
                }`}
              >
                Collections
              </Link>
            </RoleTeamGuard>
            {showVehicles && (
              <RoleTeamGuard permissions={["view.page.vehicles"]} fallback={null}>
                <Link
                  to="/vehicles"
                  className={`text-sm md:text-base px-3 py-1.5 rounded-md transition-colors ${
                    location.pathname === "/vehicles"
                      ? "text-white hover:bg-white/10"
                      : "text-white/60 hover:text-white/80"
                  }`}
                >
                  Vehicles
                </Link>
              </RoleTeamGuard>
            )}
          </div>
        </div>

        <UserDropdown />
      </div>
    </nav>
  )
}

export default TopNavigation
